
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.004 5.632a1 1 0 011.364.372l1.62 2.834A9.966 9.966 0 0112 8c1.427 0 2.784.299 4.012.838l1.62-2.834a1 1 0 011.736.992l-1.614 2.825A9.993 9.993 0 0121.951 17c.054.55-.399.999-.951.999H3c-.552 0-1.005-.449-.95-.999a9.993 9.993 0 014.196-7.18L4.632 6.995a1 1 0 01.372-1.364zM8 15a1 1 0 110-2 1 1 0 010 2zm7-1a1 1 0 102 0 1 1 0 00-2 0z"}})])
          )
        }
      }
    